import styled from 'styled-components';

export const BestOfCandidateCardFooter = styled.div`
  min-height: 40px;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  padding: 5px 10px;

  border-radius: 0 0 20px 20px;
  background: linear-gradient(to right bottom, #d9c3db 0%, #e2b3b5 25%, #ef987d 50%) right bottom /
      calc(50% + 1px) calc(50% + 1px) no-repeat,
    linear-gradient(to left bottom, #d9c3db 0%, #e2b3b5 25%, #ef987d 50%) left bottom /
      calc(50% + 1px) calc(50% + 1px) no-repeat,
    linear-gradient(to left top, #d9c3db 0%, #e2b3b5 25%, #ef987d 50%) left top / calc(50% + 1px)
      calc(50% + 1px) no-repeat,
    linear-gradient(to right top, #d9c3db 0%, #e2b3b5 25%, #ef987d 50%) right top / calc(50% + 1px)
      calc(50% + 1px) no-repeat;
`;

export const BestOfCandidateCardFooterTitle = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 1.6px;
  text-transform: uppercase;

  color: #000000;
`;
